import { UserStore } from 'builder/modules/user'
import { ResumeEditorStore } from 'builder/modules/resumeEditor'
import { EditorPanelType, GeneralEditorStore } from 'builder/modules/generalEditor'
import { useResumeEditor } from 'builder/hooks/useResumeEditor'
import { EditorPanelSwitcherItem } from 'builder/components/EditorPanelSwitcher'
import { FORMATS } from 'builder/modules/constants'

type PropsType = {
  editorState: GeneralEditorStore
  resumeState: ResumeEditorStore
  isDataLoaded: boolean
  user: UserStore
  handleOpenCustomize: () => void
  mobilePanelSwitcherItems: EditorPanelSwitcherItem<EditorPanelType>[]
  showResumeDistributionModal?: (format: FORMATS) => void
  handleDownloadDocument: () => void
  handleShareDocument?: () => void
}

export const ResumeEditorSwitcher = (props: PropsType) => {
  const ResumeEditorComponent = useResumeEditor()

  return <ResumeEditorComponent {...props} />
}
